<script>
import AdminLayout from '@layouts/admin-main'
import GrantInfo from '@components/admin/acs-grant-info'
import RoleInfo from '@components/admin/acs-role-info'
import {
  fetchGrants,
  deleteGrant,
  fetchRoles,
  deleteRole,
} from '@apis/admin/acs'

export default {
  page: {
    title: 'Admin::ACS',
    meta: [{ name: 'description', content: 'Admin::ACS' }],
  },
  components: {
    AdminLayout,
    GrantInfo,
    RoleInfo,
  },
  data() {
    return {
      grants: [],
      target_grant_seq: 0,
      show_grant_info: false,
      roles: [],
      target_role_seq: 0,
      show_role_info: false,
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      Promise.all([this.loadGrants(), this.loadRoles()]).catch((e) =>
        this.$toasted.error(e.message)
      )
    },
    async loadGrants() {
      const { data } = await fetchGrants()

      this.grants = data
    },
    async loadRoles() {
      const { data } = await fetchRoles()

      this.roles = data
    },
    handleCreateGrant() {
      this.show_grant_info = true
      this.target_grant_seq = null
    },
    handleUpdateGrant({ seq }) {
      this.show_grant_info = true
      this.target_grant_seq = seq
    },
    handleGrantSubmit(seq) {
      this.init()
      this.target_grant_seq = seq
    },
    async handleDeleteGrant(seq) {
      try {
        if (
          !(await this.$confirm(
            this.$t('admin.confirm_delete'),
            this.$t('admin.modal_confirm'),
            {
              type: 'warning',
            }
          ).catch(() => false))
        )
          return

        await deleteGrant(seq)
        await this.loadGrants()
      } catch (e) {
        this.$toasted.error(e.message)
      }
    },
    handleCreateRole() {
      this.show_role_info = true
      this.target_role_seq = null
    },
    handleUpdateRole({ seq }) {
      this.show_role_info = true
      this.target_role_seq = seq
    },
    handleRoleSubmit(seq) {
      this.init()
      this.target_role_seq = seq
    },
    async handleDeleteRole(seq) {
      try {
        if (
          !(await this.$confirm(
            this.$t('admin.confirm_delete'),
            this.$t('admin.modal_confirm'),
            {
              type: 'warning',
            }
          ).catch(() => false))
        )
          return

        await deleteRole(seq)
        await this.loadRoles()
      } catch (e) {
        this.$toasted.error(e.message)
      }
    },
  },
}
</script>

<template>
  <AdminLayout>
    <div :class="$style.adminLeftContent">
      <h3 :class="$style.xeAdmin">{{ $t('acs_catalog.manage_roles') }}</h3>
      <table cellspacing="0" cellpadding="0" :class="$style.crossTable">
        <thead>
          <tr>
            <th scope="col"
              ><div>{{ $t('acs_catalog.name') }}</div></th
            >
            <th scope="col"
              ><div>{{ $t('acs_catalog.title') }}</div></th
            >
            <th scope="col"
              ><div>{{ $t('acs_catalog.end_point_method') }}</div></th
            >
            <th scope="col"
              ><div>{{ $t('acs_catalog.end_point_path') }}</div></th
            >
            <th scope="col">
              <div :class="$style.tRight">
                <a
                  href="#"
                  :class="[$style.button, $style.black]"
                  @click.prevent="handleCreateRole"
                  ><span>{{ $t('admin.add') }}</span></a
                >
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="role in roles" :key="role.seq">
            <td :class="[$style.tCenter, $style.nowrap]">{{ role.name }}</td>
            <td :class="[$style.wide]">{{ role.title }}</td>
            <td :class="[$style.tCenter, $style.nowrap]">{{
              role.endpoint_method
            }}</td>
            <td :class="[$style.tCenter, $style.nowrap]">{{
              role.endpoint_path
            }}</td>
            <td :class="[$style.tRight, $style.nowrap]">
              <a
                href="#"
                :class="[$style.button]"
                @click.prevent="handleUpdateRole(role)"
                ><span>{{ $t('admin.modify') }}</span></a
              >
              {{ ' ' }}
              <a
                href="#"
                :class="[$style.button, $style.red]"
                @click.prevent="handleDeleteRole(role.seq)"
                ><span>{{ $t('admin.delete') }}</span></a
              >
            </td>
          </tr>
          <tr v-if="!roles.length">
            <td :colspan="5" :class="$style.tCenter">{{
              $t('acs_catalog.msg_no_role')
            }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div :class="$style.adminRightExtra">
      <h3 :class="$style.xeAdmin">{{
        $t('acs_catalog.manage_permissions')
      }}</h3>
      <table cellspacing="0" cellpadding="0" :class="$style.crossTable">
        <thead>
          <tr>
            <th scope="col"
              ><div>{{ $t('acs_catalog.name') }}</div></th
            >
            <th scope="col"
              ><div>{{ $t('acs_catalog.title') }}</div></th
            >
            <th scope="col">
              <div :class="$style.tRight">
                <a
                  href="#"
                  :class="[$style.button, $style.black]"
                  @click.prevent="handleCreateGrant"
                  ><span>{{ $t('admin.add') }}</span></a
                >
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="grant in grants" :key="grant.seq">
            <td :class="[$style.tCenter, $style.nowrap]">{{ grant.name }}</td>
            <td :class="[$style.wide]">{{ grant.title }}</td>
            <td :class="[$style.tRight, $style.nowrap]">
              <a
                href="#"
                :class="[$style.button]"
                @click.prevent="handleUpdateGrant(grant)"
                ><span>{{ $t('admin.modify') }}</span></a
              >
              {{ ' ' }}
              <a
                href="#"
                :class="[$style.button, $style.red]"
                @click.prevent="handleDeleteGrant(grant.seq)"
                ><span>{{ $t('admin.delete') }}</span></a
              >
            </td>
          </tr>
          <tr v-if="!grants.length">
            <td :colspan="3" :class="$style.tCenter">{{
              $t('acs_catalog.msg_no_role')
            }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <ElDialog
      :title="
        target_role_seq
          ? $t('acs_catalog.modify_role')
          : $t('acs_catalog.registering_role')
      "
      :visible.sync="show_role_info"
    >
      <RoleInfo
        v-if="show_role_info"
        :key="target_role_seq"
        :role_seq="target_role_seq"
        @submit="handleGrantSubmit"
      ></RoleInfo>
    </ElDialog>
    <ElDialog
      :title="
        target_grant_seq
          ? $t('acs_catalog.modify_permissions')
          : $t('acs_catalog.registration_authority')
      "
      :visible.sync="show_grant_info"
    >
      <GrantInfo
        v-if="show_grant_info"
        :key="target_grant_seq"
        :grant_seq="target_grant_seq"
        @submit="handleGrantSubmit"
      ></GrantInfo>
    </ElDialog>
  </AdminLayout>
</template>

<style lang="scss" module>
@import '@src/design/default.scss';
@import '@src/design/admin.scss';
@import '@src/design/font.scss';
@import '@src/design/button.scss';

.colTable th,
.colTable td {
  vertical-align: middle;
}
</style>
